import api from './axios';

export const getAgendaItems = (params) => api.get('/agenda-items', { params });
export const createAgendaItem = (data) => api.post('/agenda-items', data);
export const updateAgendaItem = (id, data) => api.put(`/agenda-items/${id}`, data);
export const toggleAgendaItemComplete = (id) => api.patch(`/agenda-items/${id}/toggle-complete`);
export const deleteAgendaItem = (id) => api.delete(`/agenda-items/${id}`);

export const getAgendaItemNotes = (id, params) => api.get(`/agenda-items/${id}/notes`, { params });
export const createAgendaItemNote = (id, data) => api.post(`/agenda-items/${id}/notes`, data);
export const updateAgendaItemNote = (id, noteId, data) => api.put(`/agenda-items/${id}/notes/${noteId}`, data);
export const deleteAgendaItemNote = (id, noteId) => api.delete(`/agenda-items/${id}/notes/${noteId}`);
